'use strict';

/**
 * Common functionality and utilities that is useful
 * to several different parts of the Contributor Tool.
 */
(function(_, moment) {
  window.atex = window.atex || {};
  window.atex.act = window.atex.act || {};

  /**
   * If there is no window.console, or a window.console with insufficient
   * support for the methods we want to use, we create our own wrapping
   * implementations, just re-using window.console.log();
   *
   * NOTE: The entire window.console creation block can be safely removed
   * when ACT is using version 0.9.1 or later of the OneCMS Code Library.
   */

  window.console = window.console || { log: function(s) {} };

  window.console.info = window.console.info || function(s) { window.console.log(s); };
  window.console.warn = window.console.warn || function(s) { window.console.log(s); };
  window.console.error = window.console.error || function(s) { window.console.log(s); };

  var assertRequiredParameter = function(callerFunction, parameter, parameterName) {
    if (_.isUndefined(parameter) || _.isNull(parameter)) {
      throw Error('atex.act.AngularUtils.' + callerFunction + ' called with invalid ' + parameterName + ' parameter (' + parameter + ')!');
    }
  };

  atex.act.ObjectUtils = {
    /**
     * Ensures that the given path exists in the given object and
     * that the last object in the given path is of type Array.
     *
     * Returns the original (modified) object.
     *
     * Using undefined or null for either parameter will cause en Error to be thrown.
     */
    ensurePathEndsInArray: function(object, path) {
      assertRequiredParameter('ensurePathEndsInArray', object, 'object');
      assertRequiredParameter('ensurePathEndsInArray', path, 'path');

      if (!_.isArray(path)) {
        throw Error('atex.act.ObjectUtils.ensurePathEndsInArray called with invalid path parameter type (must be Array)!');
      }

      if (path.length === 0) {
        if (!_.isArray(object)) {
          throw Error('atex.act.ObjectUtils.ensurePathEndsInArray called with invalid object parameter type (must be array when called with empty path)!');
        }

        return object;
      } else {
        if (!_.isObject(object) || _.isFunction(object) || _.isArray(object)) {
          throw Error('atex.act.ObjectUtils.ensurePathEndsInArray called with invalid object parameter type (must be plain object)!');
        }
      }

      var valueObject = object;
      var tailPath = path.slice(0, -1);

      for (var i = 0; i < tailPath.length; i++) {
        var pathSegment = tailPath[i];

        if (!_.has(valueObject, pathSegment)) {
          valueObject[pathSegment] = {};
        }

        valueObject = valueObject[pathSegment];
      }

      var tailPathSegment = path.slice(0).pop();

      if (!_.isUndefined(valueObject[tailPathSegment]) && !_.isArray(valueObject[tailPathSegment])) {
        throw Error('Expected to find value of type Array on path \'' + path + '\'!');
      }

      valueObject[tailPathSegment] = valueObject[tailPathSegment] || [];

      return object;
    }
  };

  /**
   * Genreal purpase aspect Utils
   */
  atex.act.AspectUtils = _.extend({}, atex.onecms.AngularUtils, {
    /**
     * Checks to see if at least one of the aspects in aspect names is in the content object
     * @param aspectNames
     * @param aspeects
     */
    containsAspect: function(aspectNames, content) {
      var arrayLength = aspectNames.length;
      for (var i = 0; i < arrayLength; i++) {
        if(content.data.aspects.hasOwnProperty(aspectNames[i])) {
          return true;
        }
      }
      return false;
    },

    /**
     * Removes aspects defined in filter from the content object.
     *
     * @param filter - array of string containing list a aspect names
     * @param aspeects - aspect objects
     */
    removeAspects: function(aspectNames, content) {
      aspectNames.forEach(function(aspectName) {
        delete content.data.aspects[aspectName];
      });

    }
  });

  /**
   * Utility Angular functions.
   */
  atex.act.AngularUtils = _.extend({}, atex.onecms.AngularUtils, {
    /**
     * Constructs an angular model path from a path which is an array of
     * strings. The resulting path (a string) uses bracket notation to
     * be able to deal with dots in path segments.
     *
     * Using undefined or null for the path parameter will cause en Error to be thrown.
     */
    getModelPathFromPathArray: function(path) {
      assertRequiredParameter('getModelPathFromPathArray', path, 'path');

      return path.map(function(val) { return '["' + val + '"]'; }).join('');
    },

    /**
     * Constructs a field id from a path (an array of strings).
     * The resulting id uses underscores as path separators and also
     * replaces any dot with an underscore.
     *
     * Using undefined or null for the path parameter will cause en Error to be thrown.
     */
    getFieldIdFromPathArray: function(path) {
      assertRequiredParameter('getFieldIdFromPathArray', path, 'path');

      return path.map(function(val) { return ('' + val).replace(/\./g, '_'); }).join('_');
    }
  });

  // Rest of ACT is non-localized.
  var preferredLanguage = 'en-US';

  /**
   * Utility functions for data presentation logic.
   */
  atex.act.ViewUtils = {
    toDateString: function(date) {
      return moment(date).locale(preferredLanguage).format("YYYY-MM-DD HH:mm:ss");
    },

    timeAgo: function(date,locale) {
      return moment(date).locale(locale).fromNow();
    }
  };
})(_, moment);
